import { BrowserRouter, NavLink, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AlertOctagon, CalendarCheck, LayoutDashboard, ListChecks, Settings as Cog } from "lucide-react";
import { StoreProvider } from "./tracker/store";
import Dashboard from "./tracker/pages/Dashboard";
import DailyTask from "./tracker/pages/DailyTask";
import Problems from "./tracker/pages/Problems";
import Meetings from "./tracker/pages/Meetings";
import Settings from "./tracker/pages/Settings";

const TABS = [
  ["/", "Dashboard", LayoutDashboard],
  ["/daily-task", "Daily Task", ListChecks],
  ["/problems", "Problems", AlertOctagon],
  ["/meetings", "Meetings", CalendarCheck],
  ["/settings", "Settings", Cog],
];

const NavItem = ({ to, label, Icon }) => (
  <NavLink
    to={to}
    end
    data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
    className={({ isActive }) =>
      `flex flex-1 flex-col items-center gap-1 rounded-lg px-3 py-2 text-[11px] font-semibold transition-colors sm:flex-none sm:flex-row sm:gap-2 sm:text-sm ${
        isActive ? "bg-[#c6f432]/10 text-[#c6f432]" : "text-zinc-400 hover:bg-white/5 hover:text-zinc-100"
      }`
    }
  >
    <Icon className="h-4 w-4" />
    {label}
  </NavLink>
);

const Navbar = () => (
  <header className="sticky top-0 z-40 border-b border-white/[0.07] bg-[#0b0d10]/80 backdrop-blur-xl">
    <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-3 sm:px-8">
      <div className="flex items-center gap-2.5" data-testid="app-brand">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#c6f432] font-heading text-sm font-extrabold text-[#0b0d10]">GM</span>
        <span className="font-heading text-lg font-bold tracking-tight text-zinc-50">Daily Tracker</span>
      </div>
      <nav className="hidden gap-1 sm:flex">{TABS.map(([to, l, I]) => <NavItem key={to} to={to} label={l} Icon={I} />)}</nav>
    </div>
  </header>
);

const MobileNav = () => (
  <nav className="fixed inset-x-0 bottom-0 z-40 flex gap-1 border-t border-white/[0.07] bg-[#0b0d10]/90 px-2 py-2 backdrop-blur-xl sm:hidden" data-testid="mobile-nav">
    {TABS.map(([to, l, I]) => <NavItem key={to} to={to} label={l} Icon={I} />)}
  </nav>
);

export default function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <div className="grain min-h-screen bg-[#0b0d10] text-zinc-100">
          <Navbar />
          <main className="mx-auto max-w-[1400px] px-4 pb-28 pt-8 sm:px-8 sm:pb-16">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/daily-task" element={<DailyTask />} />
              <Route path="/problems" element={<Problems />} />
              <Route path="/meetings" element={<Meetings />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <MobileNav />
        </div>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" richColors />
    </StoreProvider>
  );
}
